/**
 * @module cercaliagl/view/VNotification
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { MDCSnackbar } from '@material/snackbar';
import $ from 'jquery';
import BaseView, { EventType } from './BaseView';
import { createIconButton } from './VUtils';
/**
 * @classdesc
 */
var VNotification = /** @class */ (function (_super) {
    __extends(VNotification, _super);
    /**
     * @constructor
     * @param {string} message Message
     * @param {string} severity Severity
     */
    function VNotification(message, severity) {
        var _this = this;
        var jqElement = $("\n    <div class=\"v-notification mdc-snackbar\">\n      <div class=\"mdc-snackbar__surface\" role=\"status\" aria-relevant=\"additions\">\n        <div class=\"mdc-snackbar__label\" aria-atomic=\"false\">\n          <span class=\"icon-alert ".concat(severity, "\"></span>\n          <span class=\"text\">").concat(message, "</span>\n        </div>\n        <div class=\"mdc-snackbar__actions\" aria-atomic=\"true\">\n          ").concat(createIconButton('closeBtn', null, 'close'), "\n        </div>\n      </div>\n    </div>\n    "));
        _this = _super.call(this, jqElement) || this;
        _this.initialize_();
        return _this;
    }
    /**
     * @private
     */
    VNotification.prototype.initialize_ = function () {
        var _this = this;
        if (!this.jqElement_) {
            return;
        }
        var jqCloseBtn = this.jqElement_.find('.closeBtn');
        if (!jqCloseBtn) {
            return;
        }
        this.on(EventType.ATTACHED, function () {
            var snackbar = new MDCSnackbar(_this.jqElement_.get(0));
            snackbar.open();
        });
        jqCloseBtn.on('click', this.destroy.bind(this));
    };
    /**
     * @api
     */
    VNotification.prototype.destroy = function () {
        this.hide();
        this.jqElement_.remove();
    };
    return VNotification;
}(BaseView));
export default VNotification;
//# sourceMappingURL=VNotification.js.map